module.exports = __webpack_public_path__ + "img/19-ba40d6.png";